import { toast, ToastOptions } from 'react-toastify';

const baseOptions: ToastOptions = {
  position: 'top-right',
  hideProgressBar: true,
  autoClose: 3000,
};

export const successNotification = (text: string) => {
  toast.success(text, baseOptions);
};

export const errorNotification = (text: string) => {
  toast.error(text, baseOptions);
};
